import { LogIn, ShieldX, Trash2, KeyRound, Pencil } from 'lucide-react';

const STYLES = {
  auth: { icon: LogIn, dot: 'bg-blue-500', chip: 'bg-blue-50 text-blue-700' },
  failed: { icon: ShieldX, dot: 'bg-red-500', chip: 'bg-red-50 text-red-700' },
  destructive: { icon: Trash2, dot: 'bg-red-600', chip: 'bg-red-100 text-red-800' },
  account: { icon: KeyRound, dot: 'bg-amber-500', chip: 'bg-amber-50 text-amber-800' },
  data: { icon: Pencil, dot: 'bg-slate-400', chip: 'bg-slate-100 text-slate-700' },
};

const humanize = (a = '') => a.toLowerCase().replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());

const detailText = (details) => {
  const list = Array.isArray(details) ? details : Object.entries(details || {}).map(([field, newValue]) => ({ field, newValue }));
  return list
    .filter((d) => d.field !== 'userAgent')
    .slice(0, 3)
    .map((d) => (d.oldValue ? `${d.field}: ${d.oldValue} → ${d.newValue}` : `${d.field}: ${d.newValue}`))
    .join(' · ');
};

export const TimelineItem = ({ item, companyName, username, onPickIp, onPickUser }) => {
  const kind = item.action === 'LOGIN_FAILED' ? 'failed' : item.category;
  const s = STYLES[kind] || STYLES.data;
  const Icon = s.icon;
  const details = detailText(item.details);
  const ua = (Array.isArray(item.details) ? item.details : []).find((d) => d.field === 'userAgent')?.newValue;
  return (
    <div className="relative flex gap-3 pl-1 py-3 border-b border-slate-100 last:border-b-0" data-testid={`timeline-item-${item.id}`}>
      <div className={`mt-1 w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 ${s.chip}`}>
        <Icon className="w-3.5 h-3.5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
          <span className={`text-xs font-semibold px-2 py-0.5 rounded ${s.chip}`} data-testid="timeline-action">{humanize(item.action)}</span>
          <span className="text-sm text-slate-800 truncate">{item.entityName || item.entityType}</span>
          {item.vendorName && <span className="text-xs text-slate-500 truncate">· {item.vendorName}</span>}
        </div>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-1 text-xs text-slate-500">
          <button className="link-chip font-medium text-slate-700 hover:text-blue-700 hover:underline" onClick={() => item.userId && onPickUser(item.userId)} data-testid="timeline-user">
            {username ? `@${username}` : (item.userName || 'unknown')}
            {username && item.userName && <span className="font-normal text-slate-500"> ({item.userName})</span>}
          </button>
          {item.userRole && <span>{item.userRole}</span>}
          <span>{companyName}</span>
          {item.ip ? (
            <button className="link-chip font-mono text-slate-600 hover:text-blue-700 hover:underline" onClick={() => onPickIp(item.ip)} data-testid="timeline-ip">{item.ip}</button>
          ) : <span className="italic">no IP recorded</span>}
        </div>
        {details && <div className="text-xs text-slate-500 mt-1 truncate" title={details}>{details}</div>}
        {ua && <div className="text-[11px] text-slate-400 mt-0.5 truncate" title={ua}>{ua}</div>}
      </div>
      <div className="text-right text-xs text-slate-500 whitespace-nowrap flex-shrink-0">
        <div>{new Date(item.timestamp).toLocaleDateString()}</div>
        <div className="font-mono">{new Date(item.timestamp).toLocaleTimeString()}</div>
      </div>
    </div>
  );
};
